declare namespace $ {

	export class $shm_projects_tests extends $shm_tests_app {
		project_id( ): string
	}
	
}

//# sourceMappingURL=tests.view.tree.d.ts.map